module.exports = __webpack_public_path__ + "img/mitspeilan.9a03f9d2.png";